<template>
    <v-footer :padless="true" app dense height="35">
        <v-card class="flex" width="100%" text>
            <v-card-title style="padding-top: 0px;">
                <span style="font-size: small; color: #10303D;">{{versionValue}}&copy;</span>
                <v-btn id="goGranter" small text slot="activator" href="https://granter.com.br" target="blank">
                    <img :src="logo" class="fixedWidth" >
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn id="grLinkedin" fab small text slot="activator" href="https://www.linkedin.com/company/granter/" target="blank">
                    <v-icon color="#10303D" small>mdi-linkedin</v-icon>
                </v-btn> 
                <v-btn id="goFacebook" fab small text slot="activator" href="https://facebook.com/somosgranter" target="blank">
                    <v-icon color="#10303D" small>mdi-facebook</v-icon>
                </v-btn>
                <v-btn id="goInstagram" fab small text slot="activator" href="https://instagram.com/somosgranter" target="blank">
                    <v-icon color="#10303D" small>mdi-instagram</v-icon>
                </v-btn>
            </v-card-title>
        </v-card>
    </v-footer>
</template>

<style>
 
</style>

<script>
    import granterLogo  from "@/assets/LogoGranter-03-dark.png"

    export default {
        computed: {
            logo () {
                return granterLogo
            },
            versionValue () {
                return this.$store.state.versionValue
            }
        }
    }
</script>

<style>
    .fixedWidth {
        width: 100px;
    }
</style>

